(function () {
    'use strict';

    /* ════════════════════════════════════════════════════════════════
       Enquiry forms on contact-us.html, tourist-visa.html and
       business-visa.html. All three post JSON to send-mail.php and,
       on success, go to thank-you.html with the reference number.
    ════════════════════════════════════════════════════════════════ */

    const PHONE_RE = /^([6-9]\d{9}|\+\d{8,15})$/;   /* same rule as send-mail.php */
    const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const page = window.location.pathname.toLowerCase();

    const FORMS = [
        {
            match: 'business', formId: 'visaEnquiryForm', formType: 'business-visa',
            fields: { fullName: 'vFullName', phone: 'vPhone', email: 'vEmail', message: 'vMessage' },
            btn: 'eqSubmitBtn', btnText: 'eqBtnText', btnSpinner: 'eqBtnSpinner',
            showError: showVisaError
        },
        {
            match: 'tourist', formId: 'visaEnquiryForm', formType: 'tourist-visa',
            fields: { fullName: 'vFullName', phone: 'vPhone', email: 'vEmail', message: 'vMessage' },
            btn: 'eqSubmitBtn', btnText: 'eqBtnText', btnSpinner: 'eqBtnSpinner',
            showError: showVisaError
        },
        {
            match: 'contact', formId: 'contactForm', formType: 'contact',
            fields: { fullName: 'fullName', phone: 'phone', email: 'email', message: 'message' },
            btn: 'submitBtn', btnText: 'btnText', btnSpinner: 'btnSpinner',
            showError: showContactError
        }
    ];

    /* ════════════════════════════════════════════════════════════════
       SHARED UTILITIES
    ════════════════════════════════════════════════════════════════ */

    function setValid(el)   { el.classList.remove('is-invalid'); el.classList.add('is-valid'); }
    function setInvalid(el) { el.classList.remove('is-valid');   el.classList.add('is-invalid'); }

    function normalisePhone(v) { return v.replace(/[\s\-().]/g, ''); }

    function attachPhoneFilter(el) {
        if (!el) return;
        el.addEventListener('input', function () {
            this.value = this.value.replace(/[^\d+\s\-]/g, '').slice(0, 20);
        });
    }

    function attachCharCounter(textareaEl, counterEl) {
        if (!textareaEl || !counterEl) return;
        textareaEl.addEventListener('input', function () {
            counterEl.textContent = this.value.length;
        });
    }

    /* Only fullName, phone, email are compulsory. Message is optional. */
    function validateField(el) {
        const v = el.value.trim();
        const errEl = document.getElementById('err-' + (el.name || el.id));
        const showErr = (msg) => { if (errEl) errEl.textContent = msg; setInvalid(el); };
        const name = el.name || el.id;

        if (name === 'fullName') {
            if (v.length < 3) { showErr('Enter full name (min 3 chars)'); return false; }
            setValid(el); return true;
        }
        if (name === 'phone') {
            if (!PHONE_RE.test(normalisePhone(v))) { showErr('Enter a 10-digit mobile number, or + and country code'); return false; }
            setValid(el); return true;
        }
        if (name === 'email') {
            if (!EMAIL_RE.test(v)) { showErr('Enter valid email address'); return false; }
            setValid(el); return true;
        }
        if (name === 'message') { setValid(el); return true; }

        if (el.required) {
            if (!el.value || el.value === '') {
                if (errEl) errEl.textContent = 'This field is required.';
                setInvalid(el); return false;
            }
            setValid(el); return true;
        }
        return true;
    }

    function attachRealtimeValidation(form) {
        form.querySelectorAll('input, textarea, select').forEach(el => {
            if (el.name === 'website') return; // honeypot
            el.addEventListener('blur', () => validateField(el));
            el.addEventListener('input', () => {
                if (el.classList.contains('is-invalid')) validateField(el);
            });
        });
    }

    function validateAll(form) {
        let allOk = true;
        form.querySelectorAll('[required]').forEach(el => {
            if (!validateField(el)) allOk = false;
        });
        return allOk;
    }

    function setSending(cfg, sending) {
        const btn = document.getElementById(cfg.btn);
        const text = document.getElementById(cfg.btnText);
        const spinner = document.getElementById(cfg.btnSpinner);
        btn.disabled = sending;
        text.classList.toggle('d-none', sending);
        spinner.classList.toggle('d-none', !sending);
    }

    function showContactError(message) {
        const errEl = document.getElementById('formErrorMsg');
        errEl.textContent = message;
        errEl.classList.remove('d-none');
    }

    function showVisaError(message) {
        document.getElementById('eqErrorMsg').textContent = message;
        document.getElementById('eqError').classList.add('show');
    }

    function hideErrors() {
        const contactErr = document.getElementById('formErrorMsg');
        if (contactErr) contactErr.classList.add('d-none');
        const visaErr = document.getElementById('eqError');
        if (visaErr) visaErr.classList.remove('show');
    }

    /* ════════════════════════════════════════════════════════════════
       PACKAGE CONTEXT (contact-us.html#package=<slug>&title=<name>)
       Package pages link here so the enquiry says which package it is.
       The details travel in the # fragment so each package does not create
       another crawlable copy of this page; ?package= links still work.
    ════════════════════════════════════════════════════════════════ */

    /* query string first, then the fragment (the fragment wins) */
    function pageParams() {
        const params = new URLSearchParams(window.location.search);
        new URLSearchParams(window.location.hash.slice(1)).forEach((v, k) => params.set(k, v));
        return params;
    }

    function readPackage() {
        const params = pageParams();
        const slug = params.get('package') || '';
        if (!/^[a-z0-9-]{1,100}$/.test(slug)) return null;
        const fallback = slug.replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
        // Only plain package names are shown; anything else falls back to the slug.
        const raw = (params.get('title') || '').trim();
        const title = /^[\p{L}\p{N} &',().\-]{1,120}$/u.test(raw) ? raw : fallback;
        return { slug, title };
    }

    function showPackage(pkg, cfg) {
        showNotice(pkg.title, cfg, 'I’m interested in the ' + pkg.title + ' package.');
    }

    let autoFilled = '';

    function showNotice(subject, cfg, text) {
        const notice = document.getElementById('packageNotice');
        if (notice) {
            notice.querySelector('[data-package-title]').textContent = subject;
            notice.hidden = false;
        }
        const message = document.getElementById(cfg.fields.message);
        // fill an empty box, or replace text we filled earlier; never the visitor's own words
        if (message && (!message.value || message.value === autoFilled)) {
            message.value = text;
            autoFilled = text;
            const counter = document.getElementById('charCount');
            if (counter) counter.textContent = message.value.length;
        }
    }

    /* ════════════════════════════════════════════════════════════════
       SERVICE CONTEXT (contact-us.html#topic=<key>)
       The site menu's service links land here. Only these keys are
       accepted; the enquiry still goes out as a normal "contact" form.
    ════════════════════════════════════════════════════════════════ */

    const TOPICS = {
        'custom-holiday': { subject: 'a custom holiday',        text: 'I’d like help planning a custom holiday.' },
        'flights-hotels': { subject: 'flight & hotel bookings', text: 'I need help with flight and hotel bookings.' }
    };

    function readTopic() {
        const key = pageParams().get('topic') || '';
        return Object.prototype.hasOwnProperty.call(TOPICS, key) ? TOPICS[key] : null;
    }

    /* ════════════════════════════════════════════════════════════════
       WIRE UP THE FORM FOR THIS PAGE
    ════════════════════════════════════════════════════════════════ */

    const cfg = FORMS.find(f => page.includes(f.match));
    const form = cfg && document.getElementById(cfg.formId);
    if (!form) return;

    let pkg = null;
    function applyContext() {
        if (cfg.formType !== 'contact') return;
        pkg = readPackage();
        const topic = pkg ? null : readTopic();
        if (pkg) showPackage(pkg, cfg);
        else if (topic) showNotice(topic.subject, cfg, topic.text);
        else clearNotice(cfg);
    }

    // Back to a plain contact-us.html: drop the notice and any text we filled in.
    function clearNotice(cfg) {
        const notice = document.getElementById('packageNotice');
        if (notice) notice.hidden = true;
        const message = document.getElementById(cfg.fields.message);
        if (message && autoFilled && message.value === autoFilled) {
            message.value = '';
            autoFilled = '';
            const counter = document.getElementById('charCount');
            if (counter) counter.textContent = 0;
        }
    }
    applyContext();
    // The site menu's service links only change the fragment when the visitor is
    // already on this page.
    window.addEventListener('hashchange', applyContext);

    attachPhoneFilter(document.getElementById(cfg.fields.phone));
    attachCharCounter(document.getElementById(cfg.fields.message), document.getElementById('charCount'));
    attachRealtimeValidation(form);

    const btnRetry = document.getElementById('btnRetry');
    if (btnRetry) btnRetry.addEventListener('click', hideErrors);

    form.addEventListener('submit', async function (e) {
        e.preventDefault();
        if (document.getElementById(cfg.btn).disabled) return; // already sending
        hideErrors();

        if (!validateAll(form)) {
            form.querySelector('.is-invalid')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
            return;
        }

        const value = (id) => document.getElementById(id).value.trim();
        const honeypot = form.querySelector('[name="website"]');
        const payload = {
            formType:   pkg ? 'package' : cfg.formType,
            fullName:   value(cfg.fields.fullName),
            phone:      normalisePhone(value(cfg.fields.phone)),
            email:      value(cfg.fields.email),
            message:    value(cfg.fields.message),
            website:    honeypot ? honeypot.value : '',
            sourcePage: window.location.pathname
        };
        if (pkg) {
            payload.package = pkg.slug;
            payload.packageTitle = pkg.title;
        }

        setSending(cfg, true);
        try {
            const res = await fetch('/send-mail.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });
            const data = await res.json();
            if (res.ok && data.success) {
                window.location.href = '/thank-you.html?ref=' + encodeURIComponent(data.ref || '') +
                    '&type=' + encodeURIComponent(payload.formType);
                return; // keep the button disabled while the next page loads
            }
            cfg.showError(data.message || 'Something went wrong. Please try again or call us directly.');
        } catch (err) {
            cfg.showError('Network error — please check your connection and try again, or call +91 98208 50904.');
        }
        setSending(cfg, false);
    });

})();
